import React from 'react';
import "../css/header.css"

function Header(props) {

    return (
        
        <div className='header'>
         <img src={props.imgURL} alt=''></img>
         <div className='title'>
            <h2>{props.title}</h2>
            <p>{props.subtext}</p>
            <div className='content'>{props.content}</div>
        </div>
        </div>
       
    );
  }

  export default Header;


  